import apiClient from './api';

export type ServiceProviderWithdrawStatus =
  | 'pending_review'
  | 'processing'
  | 'pending_receive'
  | 'paid'
  | 'rejected'
  | 'failed'
  | 'canceled';

export interface ServiceProviderWithdrawReviewListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  status?: ServiceProviderWithdrawStatus | 'all';
  startDate?: string;
  endDate?: string;
}

export interface ServiceProviderWithdrawReviewItem {
  id: string;
  providerId: string;
  providerName: string;
  providerPhone: string;
  amount: number;
  method: string;
  methodText: string;
  accountName: string;
  accountNo: string;
  status: ServiceProviderWithdrawStatus | string;
  statusText: string;
  statusRemark: string;
  auditMode: string;
  beforeBalance: number;
  afterBalance: number;
  requestedAt: string;
  reviewedAt: string;
  arrivedAt: string;
  createdAt: string;
  withdrawableNow: number;
  wechatNotifyLogs?: ServiceProviderWithdrawNotifyLog[];
}

export interface ServiceProviderWithdrawNotifyLog {
  id: string;
  notifyType: string;
  status: string;
  errorMsg: string;
  responseData: string;
  createdAt: string;
}

export interface ServiceProviderWithdrawReviewListResponse {
  list: ServiceProviderWithdrawReviewItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ReviewWithdrawRequest {
  action: 'approve' | 'reject';
  remark?: string;
}

export const listServiceProviderWithdrawReviews = async (
  params?: ServiceProviderWithdrawReviewListParams,
): Promise<ServiceProviderWithdrawReviewListResponse> => {
  const response = await apiClient.get<ServiceProviderWithdrawReviewListResponse>(
    '/service-provider-withdraw-reviews',
    { params },
  );
  return response.data;
};

export const getServiceProviderWithdrawReviewDetail = async (
  id: string,
): Promise<ServiceProviderWithdrawReviewItem> => {
  const response = await apiClient.get<ServiceProviderWithdrawReviewItem>(
    `/service-provider-withdraw-reviews/${id}`,
  );
  return response.data;
};

export const reviewServiceProviderWithdraw = async (
  id: string,
  data: ReviewWithdrawRequest,
): Promise<ServiceProviderWithdrawReviewItem> => {
  const response = await apiClient.put<ServiceProviderWithdrawReviewItem>(
    `/service-provider-withdraw-reviews/${id}/review`,
    data,
  );
  return response.data;
};
